<div class="card mr-md-3 bg-transparent" [class.small]="small" [ngClass]="{ 'flex-row align-items-center': flexRow }">
  <img class="card-image" *ngIf="marketingCard.imageUrl" [src]="marketingCard.imageUrl" alt="" />
  <i class="text-primary" [class.mr-3]="flexRow" [ngClass]="marketingCard.iconClass"></i>
  <div class="card-body px-0">
    <h5 class="card-title" [class.mb-1]="flexRow">{{ marketingCard.title }}</h5>
    <p class="card-text">{{ marketingCard.body }}</p>
    <ul class="text-grey list-items" *ngIf="marketingCard.listItems">
      <li *ngFor="let listItem of marketingCard.listItems">{{ listItem }}</li>
    </ul>
    <a href="" class="card-link" *ngIf="marketingCard.linkText">{{ marketingCard.linkText }}</a>
  </div>
</div>
